import moment from "moment";

export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";
export const TIME_FORMAT = "HH:mm";
export const API_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const DATE_PARSE_FORMATS = [
  API_DATE_FORMAT,
  DATE_TIME_FORMAT,
  DATE_FORMAT,
];
export const DATE_PICKER_TIME_CONFIG = {
  format: TIME_FORMAT,
  defaultValue: moment("00:00", TIME_FORMAT),
};
